import { useRef } from 'react';
import ReplyListWriteFrame from "@/pages/comp/basic/reply/frame/list_write";
import getXcolumnJson from "../../list/xcolumn/list";
import FileListWriteFrame from '@/pages/comp/basic/file/frame/write';

function ViewPopupContent(props:any) {
  //props.rowData.a_user_name;
  const xColumnArr=getXcolumnJson();
  const fileWriteOneRef = useRef<any>(null);
  return (
    <div>
      <div className="view-table-div mt-2">
        <table>
          <colgroup>
            <col width="20%"></col>
            <col width="30%"></col>
            <col width="20%"></col>
            <col width="30%"></col>
          </colgroup>
          <tbody>
            <tr>
              <th>원생</th>
              <td>{props.rowData.a_stu_name}</td>
              <th>상담일</th>
              <td>{props.rowData.a_date}</td>
            </tr>
            <tr>
              <th>제목</th>
              <td colSpan={3}>{props.rowData.a_title}</td>
            </tr>
            <tr>
              <th colSpan={4} className="text-center">상담내용</th>
            </tr>
            <tr>
              <td colSpan={4}>
                  {
                    props.rowData.a_content && props.rowData.a_content.split('\n').map( (line:string,idx:number) => {
                      return (<span key={idx}>{line}<br/></span>)
                    })
                  }
                </td>
            </tr>
            <tr>
              <th>구분1</th>
              <td>{props.rowData.a_sort1}</td>
              <th>구분2</th>
              <td>{props.rowData.a_sort2}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn-box-center mt-2">
        <button className="btn btn-line-gray" onClick={()=>{
            props.closePopup();
            props.openOnePopup("write",true);
          }}>수정</button>
        <button className="btn btn-line-gray" onClick={()=>{props.closePopup();}}>닫기</button>
      </div>
      <FileListWriteFrame
        isView={true}
        listOpt={
          {
            s_par_id:xColumnArr.table,
            s_par_seq:props.rowData.a_ymd+","+props.rowData.a_seq,
            s_start_date:props.rowData.a_date
          }
        }
      ></FileListWriteFrame>
      <ReplyListWriteFrame
        s_start_date={props.rowData.a_start_date}
        s_par_id={xColumnArr.table}
        s_par_seq={props.rowData.a_ymd+","+props.rowData.a_seq}
      ></ReplyListWriteFrame>
    </div>
  );
}

export default ViewPopupContent;
